import * as React from "react";
import ReactToPrint from "react-to-print";

import ComponentToPrint from "./ComponentToPrint";
import { Button } from "reactstrap";
import { getDispatch } from "../../services/dispatch.service";
import { useParams } from "react-router-dom";
import { CompanyContext } from "../../contexts/CompanyContext";

const DispatchReportPrint = () => {
  const componentRef = React.useRef(null);
  const params: any = useParams();

  const onBeforeGetContentResolve = React.useRef<any>(null);

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<any>({});
  const [text, setText] = React.useState("old boring text");
  const { selectedCompany }: any = React.useContext(CompanyContext);

  React.useEffect(() => {
    getDispatch(params.id).then((response) => {
      setData(response.data);
    });
  }, []);

  // const handleAfterPrint = React.useCallback(() => {
  //   console.log("`onAfterPrint` called");
  // }, []);

  // const handleBeforePrint = React.useCallback(() => {
  //   console.log("`onBeforePrint` called");
  // }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    // console.log("`onBeforeGetContent` called");
    setLoading(true);
    setText("Loading new text...");

    return new Promise<void>((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  React.useEffect(() => {
    if (text === "New, Updated Text!" && typeof onBeforeGetContentResolve.current === "function") {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
    // to the root node of the returned component as it will be overwritten.

    // Bad: the `onClick` here will be overwritten by `react-to-print`
    // return <Button onClick={() => alert("This will not work")}>Print this out!</Button>;

    // Good
    return <Button size='sm'>Print</Button>;
  }, []);

  return (
    <div>
      <ReactToPrint
        content={reactToPrintContent}
        documentTitle='AwesomeFileName'
        // onAfterPrint={handleAfterPrint}
        onBeforeGetContent={handleOnBeforeGetContent}
        // onBeforePrint={handleBeforePrint}
        removeAfterPrint
        trigger={reactToPrintTrigger}
      />
      {loading && <p className='indicator'></p>}
      <ComponentToPrint ref={componentRef} data={data} selectedCompany={selectedCompany} />
    </div>
  );
};
export default DispatchReportPrint;
